import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { isNonEmptyArray } from '@vista-digital/utilities';
import { observer } from 'mobx-react';
import { useOccDisplayText } from '../../../../context/occ/hooks/use-occ-display-text';
import { HelpText } from '../../help-text';
import { getHelpTextId } from '../../help-text/utils/get-help-text-id';
import { PasswordInput } from '../password/password-input';
import { PasswordRuleCheckerRuleList } from './subcomponents/rule-list';
const b = bemClassBuilder('v-password-rule-checker');
export const PasswordRuleChecker = observer(props => {
    const { form: formDisplayText } = useOccDisplayText();
    const { className, rules } = props, inputProps = __rest(props, ["className", "rules"]);
    const { value, style } = inputProps;
    return (_jsxs("div", { className: b.block(undefined, className), children: [_jsx(PasswordInput, Object.assign({}, inputProps)), isNonEmptyArray(rules) && (_jsx(HelpText, { id: getHelpTextId(b.block()), className: b.element('help-text'), style: style, text: formDisplayText.passwordRuleCheckerHelpText, children: _jsx(PasswordRuleCheckerRuleList, { rules: rules, password: value, style: style }) }))] }));
});
PasswordRuleChecker.displayName = 'PasswordRuleChecker';
//# sourceMappingURL=password-rule-checker.js.map